import React from 'react';
import styled from 'styled-components';

const ContainerWrapper = styled.div`
  max-width: ${props => props.narrow ? '800px' : '1200px'};
  margin: 0 auto;
  padding: 0 2rem;
  width: 100%;
  background: none;
  border: none;
  box-shadow: none;
  border-radius: 0;
  backdrop-filter: none;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

function Container({ children, narrow, ...props }) {
  return (
    <ContainerWrapper narrow={narrow} {...props}>
      {children}
    </ContainerWrapper>
  );
}

export default Container; 